import React from 'react';

interface SidebarProps {
  isConfigured: boolean;
  repoOwner: string;
  repoName: string;
}

export const Sidebar: React.FC<SidebarProps> = ({ isConfigured, repoOwner, repoName }) => {
  return (
    <div 
      style={{
        width: '300px',
        backgroundColor: '#f8f9fa',
        padding: '20px',
        borderRight: '1px solid #dee2e6',
        height: '100vh',
        overflowY: 'auto',
        boxSizing: 'border-box',
      }}
    >
      <h2 style={{ marginTop: 0, color: '#495057' }}>ℹ️ About</h2>
      
      <div style={{ marginBottom: '20px', fontSize: '14px', lineHeight: '1.5' }}>
        <p>
          This application allows you to browse tags and commits from any GitHub repository.
        </p>
        
        <h4 style={{ marginTop: '20px', color: '#495057' }}>Features:</h4>
        <ul style={{ paddingLeft: '20px', margin: 0 }}>
          <li>View all repository tags ordered by creation date</li>
          <li>Select two tags to see commits between them</li>
          <li>Automatic ticket number highlighting (PROJ-123)</li>
          <li>View detailed commit information with hyperlinks</li>
          <li>Direct links to GitHub commits</li>
          <li>Token saved securely in browser local storage</li>
        </ul>
        
        <h4 style={{ marginTop: '20px', color: '#495057' }}>Setup:</h4>
        <p>
          Enter your GitHub configuration above. All settings are saved in your browser's local storage for future sessions.
        </p>
      </div>

      <div style={{ 
        padding: '10px', 
        backgroundColor: isConfigured ? '#d4edda' : '#f8d7da',
        border: `1px solid ${isConfigured ? '#c3e6cb' : '#f5c6cb'}`,
        borderRadius: '4px',
        marginBottom: '20px'
      }}>
        <strong>Configuration:</strong> {isConfigured ? '✅ Ready' : '❌ Not configured'}
        {isConfigured && repoOwner && repoName && (
          <div style={{ marginTop: '5px', fontSize: '14px', color: '#495057' }}>
            Repository: {repoOwner}/{repoName}
          </div>
        )}
      </div>

      {!isConfigured && (
        <div style={{ 
          padding: '10px', 
          backgroundColor: '#d1ecf1',
          border: '1px solid #bee5eb',
          borderRadius: '4px',
          marginBottom: '20px',
          fontSize: '14px'
        }}>
          Enter your GitHub configuration above to get started.
        </div>
      )}

      <hr style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #dee2e6' }} />

      <h2 style={{ color: '#495057' }}>🔗 Links</h2>
      <div style={{ fontSize: '14px' }}>
        {isConfigured && repoOwner && repoName && (
          <div style={{ marginBottom: '10px' }}>
            <a 
              href={`https://github.com/${repoOwner}/${repoName}`} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#007bff', textDecoration: 'none' }}
            >
              {repoOwner}/{repoName} Repository
            </a>
          </div>
        )}
        <div>
          <a 
            href="https://docs.github.com/en/rest" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#007bff', textDecoration: 'none' }}
          >
            GitHub API Documentation
          </a>
        </div>
      </div>
    </div>
  );
};
